import wrapperHOC from "@Utils/wrapperHOC";
import ReviewsSectionV2 from "../ReviewsSectionV2";
import ReviewsSection from ".";
import { GROWTH_BOOK_FEATURE_FLAG_NAMES } from "constants/index";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { shallowEqual, useSelector } from "react-redux";
import { AppState } from "@Store/index";
import config from "@Config/index";

const ReviewSectionWrapper = ({ isDesktop = false }) => {
  const { inventory } = useSelector(
    ({ propertyPageData }: AppState) => ({
      inventory: propertyPageData.data,
    }),
    shallowEqual,
  );
  const isReviewsSectionV2Enabled =
    (useFeatureIsOn(GROWTH_BOOK_FEATURE_FLAG_NAMES.REVIEWS_SECTION_V2) || config.IS_CHINA_APP) &&
    inventory?.meta?.review_summary?.summary;
  if (isDesktop) {
    return isReviewsSectionV2Enabled ? (
      <ReviewsSectionV2 isDesktop />
    ) : (
      <ReviewsSection isDesktop />
    );
  }

  return isReviewsSectionV2Enabled ? <ReviewsSectionV2 /> : <ReviewsSection />;
};
export default wrapperHOC(ReviewSectionWrapper, {
  componentName: "ReviewSectionWrapper-PropertyPage",
  showForChina: true,
});
